export function computePositionInCanvas(dataGraphics, clientX, clientY) {                         //calcula a posição com referência no canvas
    if(dataGraphics.canvas){
        const canvasBoundaries = dataGraphics.canvas.getBoundingClientRect()      //obem os limites do canvas.
        return {
            x : clientX - canvasBoundaries.left,
            y : -(clientY - canvasBoundaries.bottom)                            //negativo pois o canvas computa o valor a partir do topo e nós queremos a bartir de baixo.
        }
    }else{
        return null
    }
}